<template>
<div class="chapter">
<div class="inner_page">
<div class="ipadfp"><img alt="Oath of Honor: A Thriller, by Matthew Betley." class="imagefp" src="images/9781476799285.jpg"/></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// cover.vue?c30cfe52